// react
import React, { useContext, useState } from 'react'
import PropTypes from 'prop-types'

// apollo
import { useQuery, useLazyQuery } from '@apollo/client'

// react router
import { Link, useLocation } from 'react-router-dom'

// contexts
import AuthContext from '../../utils/authProvider'

// ant design
import { Menu } from 'antd'
import {
  DesktopOutlined,
  FileOutlined,
  UserOutlined,
  TableOutlined
} from '@ant-design/icons'

// operations
import { QUERY_DISTRICT_REPORTS_LIST } from '../../operations/queries/districtreports'
import { QUERY_USER_DISTRICT_REPORTS_LIST } from '../../operations/queries/districtreports'

const SideMenu = ({ mode, theme }) => {
  const Auth = useContext(AuthContext)
  const location = useLocation()
  //const { userId, currentDistrictId } = Auth;
  const userId = '640c9fd536dba856e0df0d35' //For testing
  const currentDistrictId = '63a0d40ee026754af40b9b42'  //Why is currentDistrictId null in Auth?

  const canViewDistrictReports = Auth.hasPermission('VIEW_DISTRICT_REPORTS')
  const canViewSchoolReports = Auth.hasPermission('VIEW_SCHOOL_REPORTS')
  const canViewStudentReports = Auth.hasPermission('VIEW_STUDENT_REPORTS')
  const canViewMeetingReports = Auth.hasPermission('VIEW_MEETING_REPORTS')
  const canViewUserReports = Auth.hasPermission('VIEW_USER_REPORTS')
  const canViewStudentFormReports = Auth.hasPermission('VIEW_STUDENT_FORM_REPORTS')
  const canViewSuperAdminReports = Auth.hasPermission('VIEW_SUPER_REPORTS')

  const canListDistricts = Auth.hasPermission('LIST_DISTRICTS')
  const canListSchools = Auth.hasPermission('LIST_SCHOOLS')
  const canListUsers = Auth.hasPermission('LIST_USERS')
  const canListStudents = Auth.hasPermission('LIST_STUDENTS')
  const canListGrades = Auth.hasPermission('LIST_GRADES')
  const canListLookups = Auth.hasPermission('LIST_LOOKUPS')
  const canListDistrictForms = Auth.hasPermission('LIST_DISTRICT_FORMS')
  const canListDocuments = Auth.hasPermission('LIST_DOCUMENTS')
  const canAddImports = Auth.hasPermission('ADD_IMPORTS')
  const isSuperAdmin = Auth.hasRole('SUPER_ADMIN')

  return (
    <>
      <div className='appMenu'>
        <Menu
          theme={theme}
          defaultSelectedKeys={['/']}
          mode={mode}
          selectedKeys={[location.pathname]}
          style={{ background: 'transparent' }}
        >
          <Menu.Item key='/' icon={<DesktopOutlined />}>
            <Link to='/'>Dashboard</Link>
          </Menu.Item>

          {canListDistricts && (
            <>
              <Menu.Item key='/districts' icon={<FileOutlined />}>
                <Link to='/districts'>Districts</Link>
              </Menu.Item>
            </>
          )}

          {canListSchools && (
            <>
              <Menu.Item key='/schools' icon={<FileOutlined />}>
                <Link to='/schools'>Schools</Link>
              </Menu.Item>
            </>
          )}

          {canListUsers && (
            <>
              <Menu.Item key='/users' icon={<FileOutlined />}>
                <Link to='/users'>Users</Link>
              </Menu.Item>
            </>
          )}

          {canListStudents && (
            <>
              <Menu.Item key='/students' icon={<UserOutlined />}>
                <Link to='/students'>Students</Link>
              </Menu.Item>
            </>
          )}

          {canListGrades && isSuperAdmin && (
            <>
              <Menu.Item key='/grades' icon={<FileOutlined />}>
                <Link to='/grades'>Grades</Link>
              </Menu.Item>
            </>
          )}

          {canListLookups && (
            <>
              <Menu.Item key='/lookups' icon={<TableOutlined />}>
                <Link to='/lookups'>Lookups</Link>
              </Menu.Item>
            </>
          )}

          {canListDistrictForms && (
            <>
              <Menu.Item key='/districtforms' icon={<FileOutlined />}>
                <Link to='/districtforms'>District forms</Link>
              </Menu.Item>
            </>
          )}
          {/* currently broken */}
          {/* {canListDocuments && (
            <>
              <Menu.Item key='/documents' icon={<FileOutlined />}>
                <Link to='/documents'>Documents</Link>
              </Menu.Item>
            </>
          )} */}

          <Menu.SubMenu key="reports" title="Reports" icon={<FileOutlined />}>
            {canViewDistrictReports && (
              <>
                <Menu.Item key='/reports/districts'>
                  <Link to='/report/districtmetricsreport'>Districts</Link>
                </Menu.Item>
              </>
            )}
            {canViewSchoolReports && (
              <>
                <Menu.Item key='/reports/schools'>
                  <Link to='/report/schoolmetricsreport'>Schools</Link>
                </Menu.Item>
              </>
            )}
            {canViewStudentReports && (
              <>
                <Menu.Item key='/reports/students'>
                  <Link to='/report/studentmetricsreport'>Students</Link>
                </Menu.Item>
              </>
            )}
            {canViewMeetingReports && (
              <>
                <Menu.Item key='/reports/meetings'>
                  <Link to='/report/meetingmetricsreport'>Meetings</Link>
                </Menu.Item>
              </>
            )}
            {canViewUserReports && (
              <>
                <Menu.Item key='/reports/users'>
                  <Link to='/report/usermetricsreport'>Users</Link>
                </Menu.Item>
              </>
            )}
            {canViewStudentFormReports && (
              <>
                <Menu.SubMenu key="/reports/studentForms/healthplan" title="Student Forms">
                  <Menu.Item key="healthPlan">
                  <Link to='/report/studentforms/healthplanreport'>Health Plan</Link>
                  </Menu.Item>
                </Menu.SubMenu>
              </>
            )}


          </Menu.SubMenu>

          {canAddImports && (
            <>
              <Menu.Item key='/imports/add' icon={<FileOutlined />}>
                <Link to='/imports/add'>Import</Link>
              </Menu.Item>
            </>
          )}
        </Menu>
      </div>
    </>
  )
}

SideMenu.propTypes = {
  mode: PropTypes.string.isRequired,
  theme: PropTypes.string.isRequired
}

export default SideMenu
